var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 45.5187 20.7775 C 45.5187 17.0541 45.8614 19.0351 45.5184 20.7771 C 46.0493 22.1469 45.0112 24.5199 43.4182 27.9107 C 41.8186 31.9343 34.7315 35.5153 27.844 34.0807 C 20.0905 32.2562 14.4988 24.1849 14.4988 20.4614 C 14.4988 20.4614 19.9855 19.0648 24.0156 20.8892 C 24.8818 21.2792 25.6745 21.8122 26.3947 22.4165 C 29.1172 24.7067 29.8558 24.9763 33.5852 22.4898 C 34.3176 21.9003 35.1211 21.3835 35.995 21.0113 C 40.0615 19.2693 45.5187 20.7775 45.5187 20.7775 C 45.5187 20.7775 45.5187 20.7775 45.5187 20.7775"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "#b1cc33;#FCEA2B;#b1cc33"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "#b1cc33;transparent;#b1cc33"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeWidth",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "2;undefined;2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeLinejoin",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "round;undefined;round"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeMiterlimit",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "10;undefined;10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "M 58.6128 14.8309 C 58.6128 14.8309 54.8917 21.7833 49.2367 24.2059 C 44.7971 26.1108 39.1559 25.2132 36.9405 24.7506 C 34.7161 25.168 29.0579 25.9504 24.657899999999998 23.955399999999997 C 19.0535 21.418099999999995 15.474899999999998 14.391299999999998 15.474899999999998 14.391299999999998 C 15.474899999999998 14.391299999999998 23.1051 12.448999999999998 28.7095 14.986199999999997 C 29.914099999999998 15.528499999999998 31.016499999999997 16.269799999999996 32.018 17.110099999999996 C 35.804 20.294999999999995 36.8311 20.669899999999995 42.0175 17.211999999999996 C 43.0359 16.392299999999995 44.1533 15.673599999999997 45.3686 15.155999999999995 C 51.0237 12.7335 58.6128 14.8309 58.6128 14.8309 C 58.6128 14.8309 58.6128 14.8309 58.6128 14.8309;M 12 36 C 12 22.7451660048 22.7451660048 12 36 12 C 49.2548339952 12 60 22.7451660048 60 36 C 60 49.2548339952 49.2548339952 60 36 60 C 22.7451660048 60 12 49.2548339952 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36;M 58.6128 14.8309 C 58.6128 14.8309 54.8917 21.7833 49.2367 24.2059 C 44.7971 26.1108 39.1559 25.2132 36.9405 24.7506 C 34.7161 25.168 29.0579 25.9504 24.657899999999998 23.955399999999997 C 19.0535 21.418099999999995 15.474899999999998 14.391299999999998 15.474899999999998 14.391299999999998 C 15.474899999999998 14.391299999999998 23.1051 12.448999999999998 28.7095 14.986199999999997 C 29.914099999999998 15.528499999999998 31.016499999999997 16.269799999999996 32.018 17.110099999999996 C 35.804 20.294999999999995 36.8311 20.669899999999995 42.0175 17.211999999999996 C 43.0359 16.392299999999995 44.1533 15.673599999999997 45.3686 15.155999999999995 C 51.0237 12.7335 58.6128 14.8309 58.6128 14.8309 C 58.6128 14.8309 58.6128 14.8309 58.6128 14.8309"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;36;undefined"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;36;undefined"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;24;undefined"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;24;undefined"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "ry",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;24;undefined"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 47.034 38.7182 C 46.8111 44.1199 41.8261 48.2636 36.5106 49.3782 C 40.198 49.3854 43.1805 52.4038 43.1446 56.1345 C 43.1446 59.8579 40.047 62.8764 36.3236 62.8764 C 32.4491 62.8764 29.2869 59.8507 29.1287 56.1201 C 20.9742 54.2792 13.1074 47.1099 12.2876 38.7182 C 12.2876 37.4526 12.4243 36.2085 12.6831 35.0149 C 13.1434 32.8648 14.0134 30.8585 15.1928 29.0824 C 17.0911 27.0042 19.9028 25.6955 23.0452 25.6955 C 24.6775 25.6955 26.2092 26.0406 27.5826 26.6662 C 28.5103 27.0905 29.5458 27.1984 30.5237 26.9826 C 30.8473 26.9179 31.1709 26.8101 31.4801 26.6662 C 32.8464 26.0406 34.3852 25.6955 36.0104 25.6955 C 39.5195 25.6955 42.626 27.3278 44.4956 29.8374 C 44.7041 30.1035 44.8839 30.3767 45.0565 30.6572 C 45.4089 31.3259 45.7109 32.0163 45.9769 32.7281 C 45.9841 32.7425 45.9913 32.7497 45.9913 32.7641 C 46.0776 32.9942 46.1567 33.2315 46.2286 33.4688 C 46.2933 33.6773 46.3581 33.8859 46.4156 34.0944 C 46.4659 34.2814 46.5162 34.4612 46.5594 34.6481 C 46.8254 35.7699 46.9836 36.9348 47.0268 38.1213 C 47.034 38.3227 47.034 38.5168 47.034 38.7182 C 47.034 38.7182 47.034 38.7182 47.034 38.7182"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "#FFA7C0;#FCEA2B;#FFA7C0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "#FFA7C0;transparent;#FFA7C0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeWidth",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "2;undefined;2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeLinecap",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "round;undefined;round"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeLinejoin",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "round;undefined;round"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeMiterlimit",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "10;undefined;10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "M 60.72 39.78 C 60.41 52.47 49.28 62.43 36.71 63.98 C 36.660000000000004 63.989999999999995 36.61 63.989999999999995 36.56 64 C 36.56 64 36.45 64 36.45 64 C 36.24 64 36.040000000000006 63.99 35.82 63.98 C 24.48 61.419999999999995 13.54 51.449999999999996 12.399999999999999 39.78 C 12.399999999999999 38.02 12.589999999999998 36.29 12.95 34.63 C 13.59 31.64 14.799999999999999 28.85 16.439999999999998 26.380000000000003 C 19.08 23.490000000000002 22.99 21.67 27.36 21.67 C 29.63 21.67 31.759999999999998 22.150000000000002 33.67 23.020000000000003 C 34.96 23.610000000000003 36.4 23.7601 37.760000000000005 23.460000000000004 C 38.21000000000001 23.370000000000005 38.660000000000004 23.220000000000006 39.09 23.020000000000003 C 40.99 22.150000000000002 43.13 21.67 45.39 21.67 C 50.27 21.67 54.59 23.94 57.19 27.43 C 57.48 27.8 57.73 28.18 57.97 28.57 C 58.4601 29.5 58.879999999999995 30.46 59.25 31.45 C 59.26 31.47 59.27 31.48 59.27 31.5 C 59.39 31.82 59.5 32.15 59.6 32.48 C 59.690000000000005 32.769999999999996 59.780100000000004 33.059999999999995 59.86 33.349999999999994 C 59.93 33.60999999999999 60 33.85999999999999 60.06 34.12 C 60.43 35.68 60.650000000000006 37.3 60.71 38.949999999999996 C 60.72 39.23 60.72 39.5 60.72 39.78 C 60.72 39.78 60.72 39.78 60.72 39.78;M 12 36 C 12 22.7451660048 22.7451660048 12 36 12 C 49.2548339952 12 60 22.7451660048 60 36 C 60 49.2548339952 49.2548339952 60 36 60 C 22.7451660048 60 12 49.2548339952 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36 C 12 36 12 36 12 36;M 60.72 39.78 C 60.41 52.47 49.28 62.43 36.71 63.98 C 36.660000000000004 63.989999999999995 36.61 63.989999999999995 36.56 64 C 36.56 64 36.45 64 36.45 64 C 36.24 64 36.040000000000006 63.99 35.82 63.98 C 24.48 61.419999999999995 13.54 51.449999999999996 12.399999999999999 39.78 C 12.399999999999999 38.02 12.589999999999998 36.29 12.95 34.63 C 13.59 31.64 14.799999999999999 28.85 16.439999999999998 26.380000000000003 C 19.08 23.490000000000002 22.99 21.67 27.36 21.67 C 29.63 21.67 31.759999999999998 22.150000000000002 33.67 23.020000000000003 C 34.96 23.610000000000003 36.4 23.7601 37.760000000000005 23.460000000000004 C 38.21000000000001 23.370000000000005 38.660000000000004 23.220000000000006 39.09 23.020000000000003 C 40.99 22.150000000000002 43.13 21.67 45.39 21.67 C 50.27 21.67 54.59 23.94 57.19 27.43 C 57.48 27.8 57.73 28.18 57.97 28.57 C 58.4601 29.5 58.879999999999995 30.46 59.25 31.45 C 59.26 31.47 59.27 31.48 59.27 31.5 C 59.39 31.82 59.5 32.15 59.6 32.48 C 59.690000000000005 32.769999999999996 59.780100000000004 33.059999999999995 59.86 33.349999999999994 C 59.93 33.60999999999999 60 33.85999999999999 60.06 34.12 C 60.43 35.68 60.650000000000006 37.3 60.71 38.949999999999996 C 60.72 39.23 60.72 39.5 60.72 39.78 C 60.72 39.78 60.72 39.78 60.72 39.78"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;36;undefined"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;36;undefined"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;24;undefined"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;24;undefined"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "ry",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;24;undefined"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 55.7523 44.2757 C 55.5294 53.6069 47.3692 60.936 38.1369 62.0506 C 52.6723 58.6572 60.7268 30.465 41.042 32.5823 C 42.4019 32.3163 43.9781 31.8617 44.352 31.6557 C 47.667 31.6557 50.6225 32.6183 52.5137 34.8978 C 52.7222 35.1638 52.902 34.7019 53.0746 34.9824 C 53.427 35.6511 54.645 35.9979 54.911 36.7098 C 54.9182 36.7242 55.6949 36.2734 55.6949 36.2878 C 55.7812 36.5179 55.8603 38.6577 55.9322 38.895 C 55.9969 39.1035 56.0617 40.6333 56.1191 40.8418 C 56.1695 41.272 55.9998 41.6489 55.7715 41.8359 C 56.052 42.9577 56.2174 44.1154 56.239 45.3091 C 55.9748 45.5104 55.7547 45.5074 55.7547 45.4655 C 55.7547 45.4655 55.7547 44.1444 55.7547 44.1444"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "#E67A94;#92D3F5;#E67A94"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "#E67A94;transparent;#E67A94"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeWidth",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "2;undefined;2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeLinejoin",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "round;undefined;round"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeMiterlimit",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "10;undefined;10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "M 60.72 39.78 C 60.41 52.47 49.28 62.43 36.71 63.98 C 56.9236 59.261 68.1247 20.0555 40.75 23 C 42.91 22.63 45.32 22.23 45.84 22.23 C 50.45 22.23 54.56 24.26 57.190000000000005 27.43 C 57.480000000000004 27.8 57.730000000000004 28.18 57.970000000000006 28.57 C 58.460100000000004 29.5 58.88 30.46 59.25000000000001 31.45 C 59.260000000000005 31.47 59.27000000000001 31.48 59.27000000000001 31.5 C 59.39000000000001 31.82 59.50000000000001 32.15 59.60000000000001 32.48 C 59.69000000000001 32.769999999999996 59.78010000000001 33.059999999999995 59.86000000000001 33.349999999999994 C 59.93000000000001 33.60999999999999 60.00000000000001 33.85999999999999 60.06000000000001 34.12 C 60.45000000000001 35.68 60.68000000000001 37.29 60.71000000000001 38.949999999999996 C 60.72 39.23 60.72 39.5 60.72 39.78 C 60.72 39.78 60.72 39.78 60.72 39.78;M 43.0359 55.7841 C 43.0359 56.5173 42.4779 57.1116 41.7895 57.1116 C 41.7895 57.1116 41.7895 57.1116 41.7895 57.1116 C 41.1012 57.1116 40.543099999999995 56.517300000000006 40.543099999999995 55.7841 C 40.543099999999995 55.7841 40.543099999999995 54.0141 40.543099999999995 54.0141 C 40.543099999999995 54.0141 40.543099999999995 51.397 40.543099999999995 51.397 C 40.543099999999995 51.397 43.803999999999995 50.1742 43.803999999999995 50.1742 C 43.803999999999995 50.1742 46.543099999999995 48.5438 46.543099999999995 48.5438 C 46.543099999999995 48.5438 46.543099999999995 55.316399999999994 46.543099999999995 55.316399999999994 C 46.543099999999995 55.316399999999994 46.543099999999995 60.0196 46.543099999999995 60.0196 C 46.543099999999995 60.8854 45.759899999999995 61.5873 44.7938 61.5873 C 44.7938 61.5873 44.7938 61.5873 44.7938 61.5873 C 43.8277 61.5873 43.0445 60.8854 43.0445 60.0196 C 43.0445 60.0196 43.0445 55.316399999999994 43.0445 55.316399999999994;M 60.72 39.78 C 60.41 52.47 49.28 62.43 36.71 63.98 C 56.9236 59.261 68.1247 20.0555 40.75 23 C 42.91 22.63 45.32 22.23 45.84 22.23 C 50.45 22.23 54.56 24.26 57.190000000000005 27.43 C 57.480000000000004 27.8 57.730000000000004 28.18 57.970000000000006 28.57 C 58.460100000000004 29.5 58.88 30.46 59.25000000000001 31.45 C 59.260000000000005 31.47 59.27000000000001 31.48 59.27000000000001 31.5 C 59.39000000000001 31.82 59.50000000000001 32.15 59.60000000000001 32.48 C 59.69000000000001 32.769999999999996 59.78010000000001 33.059999999999995 59.86000000000001 33.349999999999994 C 59.93000000000001 33.60999999999999 60.00000000000001 33.85999999999999 60.06000000000001 34.12 C 60.45000000000001 35.68 60.68000000000001 37.29 60.71000000000001 38.949999999999996 C 60.72 39.23 60.72 39.5 60.72 39.78 C 60.72 39.78 60.72 39.78 60.72 39.78"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M 55.6998 44.3542 C 55.4769 53.6854 47.3167 61.0144 38.0843 62.129 C 52.6197 58.7356 60.6743 30.5434 40.9894 32.6608 C 42.3493 32.3947 43.9256 31.9401 44.2995 31.7342 C 47.6145 31.7342 50.5699 32.6967 52.4611 34.9762 C 52.6697 35.2423 52.8494 34.7804 53.022 35.0608 C 53.3744 35.7296 54.5924 36.0764 54.8585 36.7883 C 54.8657 36.8027 55.6423 36.3518 55.6423 36.3662 C 55.7286 36.5963 55.8077 38.7361 55.8796 38.9734 C 55.9443 39.182 56.0091 40.7117 56.0666 40.9202 C 56.1169 41.3504 55.9472 41.7274 55.719 41.9143 C 55.9994 43.0361 56.1648 44.1938 56.1864 45.3875 C 55.9222 45.5889 55.7022 45.5858 55.7022 45.544 C 55.7022 45.544 55.7022 44.2228 55.7022 44.2228"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "#E67A94;transparent;#E67A94"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "#E67A94;#000000;#E67A94"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "M 60.72 39.78 C 60.41 52.47 49.28 62.43 36.71 63.98 C 56.9236 59.261 68.1247 20.0555 40.75 23 C 42.91 22.63 45.32 22.23 45.84 22.23 C 50.45 22.23 54.56 24.26 57.190000000000005 27.43 C 57.480000000000004 27.8 57.730000000000004 28.18 57.970000000000006 28.57 C 58.460100000000004 29.5 58.88 30.46 59.25000000000001 31.45 C 59.260000000000005 31.47 59.27000000000001 31.48 59.27000000000001 31.5 C 59.39000000000001 31.82 59.50000000000001 32.15 59.60000000000001 32.48 C 59.69000000000001 32.769999999999996 59.78010000000001 33.059999999999995 59.86000000000001 33.349999999999994 C 59.93000000000001 33.60999999999999 60.00000000000001 33.85999999999999 60.06000000000001 34.12 C 60.45000000000001 35.68 60.68000000000001 37.29 60.71000000000001 38.949999999999996 C 60.72 39.23 60.72 39.5 60.72 39.78 C 60.72 39.78 60.72 39.78 60.72 39.78;M 42.8488 56.0633 C 42.8488 56.796499999999995 42.2908 57.3908 41.602399999999996 57.3908 C 41.602399999999996 57.3908 41.602399999999996 57.3908 41.602399999999996 57.3908 C 40.9141 57.3908 40.355999999999995 56.7965 40.355999999999995 56.0633 C 40.355999999999995 56.0633 40.355999999999995 54.293299999999995 40.355999999999995 54.293299999999995 C 40.355999999999995 54.293299999999995 40.355999999999995 51.676199999999994 40.355999999999995 51.676199999999994 C 40.355999999999995 51.676199999999994 43.616899999999994 50.453399999999995 43.616899999999994 50.453399999999995 C 43.616899999999994 50.453399999999995 46.355999999999995 48.82299999999999 46.355999999999995 48.82299999999999 C 46.355999999999995 48.82299999999999 46.355999999999995 55.59559999999999 46.355999999999995 55.59559999999999 C 46.355999999999995 55.59559999999999 46.355999999999995 60.29879999999999 46.355999999999995 60.29879999999999 C 46.355999999999995 61.16459999999999 45.572799999999994 61.866499999999995 44.6067 61.866499999999995 C 44.6067 61.866499999999995 44.6067 61.866499999999995 44.6067 61.866499999999995 C 43.6406 61.866499999999995 42.8574 61.16459999999999 42.8574 60.29879999999999 C 42.8574 60.29879999999999 42.8574 55.59559999999999 42.8574 55.59559999999999;M 60.72 39.78 C 60.41 52.47 49.28 62.43 36.71 63.98 C 56.9236 59.261 68.1247 20.0555 40.75 23 C 42.91 22.63 45.32 22.23 45.84 22.23 C 50.45 22.23 54.56 24.26 57.190000000000005 27.43 C 57.480000000000004 27.8 57.730000000000004 28.18 57.970000000000006 28.57 C 58.460100000000004 29.5 58.88 30.46 59.25000000000001 31.45 C 59.260000000000005 31.47 59.27000000000001 31.48 59.27000000000001 31.5 C 59.39000000000001 31.82 59.50000000000001 32.15 59.60000000000001 32.48 C 59.69000000000001 32.769999999999996 59.78010000000001 33.059999999999995 59.86000000000001 33.349999999999994 C 59.93000000000001 33.60999999999999 60.00000000000001 33.85999999999999 60.06000000000001 34.12 C 60.45000000000001 35.68 60.68000000000001 37.29 60.71000000000001 38.949999999999996 C 60.72 39.23 60.72 39.5 60.72 39.78 C 60.72 39.78 60.72 39.78 60.72 39.78"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeLinecap",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "undefined;round;undefined"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 40.6525 38.7907 C 40.136 37.3167 37.0861 36.6119 34.8477 36.6119 C 32.6098 36.6119 31.4784 35.8125 31.4784 34.8123 C 31.4784 34.8123 31.5048 34.8123 31.5048 34.8123 C 31.5048 34.8123 34.9144 35.6727 38.1576 34.8308 C 38.1576 34.8308 38.2028 34.8123 38.2028 34.8123 C 38.2028 34.8123 38.2028 34.8123 38.2028 34.8123"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "transparent;#EA5A47;transparent"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "#E67A94;transparent;#E67A94"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeWidth",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "2;undefined;2"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeLinecap",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "round;undefined;round"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeLinejoin",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "round;undefined;round"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "strokeMiterlimit",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "10;undefined;10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "M 37.7192 36.595 C 37.001 33.150999999999996 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625;M 48.1612 44.4112 C 48.1612 47.9803 44.1861 50.8174 36.217600000000004 50.8174 C 28.251000000000005 50.8174 24.223700000000004 47.9716 24.223700000000004 44.4112 C 24.223700000000004 44.4112 24.317600000000006 44.4112 24.317600000000006 44.4112 C 24.317600000000006 44.4112 36.4551 47.4739 48.000600000000006 44.4772 C 48.000600000000006 44.4772 48.1612 44.4112 48.1612 44.4112 C 48.1612 44.4112 48.1612 44.4112 48.1612 44.4112;M 37.7192 36.595 C 37.001 33.150999999999996 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M 40.5999 38.8691 C 40.0835 37.3952 37.0336 36.6903 34.7951 36.6903 C 32.5572 36.6903 31.4259 35.8909 31.4259 34.8907 C 31.4259 34.8907 31.4523 34.8907 31.4523 34.8907 C 31.4523 34.8907 34.8618 35.7511 38.1051 34.9093 C 38.1051 34.9093 38.1502 34.8907 38.1502 34.8907 C 38.1502 34.8907 38.1502 34.8907 38.1502 34.8907"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "#E67A94;#000000;#E67A94"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "M 37.7192 36.595 C 37.001 33.150999999999996 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625;M 47.9741 44.6904 C 47.9741 48.259499999999996 43.999 51.096599999999995 36.0305 51.096599999999995 C 28.063900000000004 51.096599999999995 24.036600000000004 48.2508 24.036600000000004 44.6904 C 24.036600000000004 44.6904 24.130500000000005 44.6904 24.130500000000005 44.6904 C 24.130500000000005 44.6904 36.268 47.753099999999996 47.813500000000005 44.7564 C 47.813500000000005 44.7564 47.9741 44.6904 47.9741 44.6904 C 47.9741 44.6904 47.9741 44.6904 47.9741 44.6904;M 37.7192 36.595 C 37.001 33.150999999999996 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625 C 34.3125 31.0625 34.3125 31.0625 34.3125 31.0625"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M 42.6856 47.7892 C 43.9791 42.4396 44.6234 34.7247 39.3094 29.5914 C 39.0119 29.4892 38.7149 29.4892 38.3893 29.5215"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "M 40.9874 52.864 C 43.028800000000004 45.697199999999995 44.2314 35.2482 37.25 28.249999999999996 C 37.25 28.249999999999996 37.25 28.249999999999996 37.25 28.249999999999996;M 47.0328 34.7984 C 46.4118 34.1008 45.6268 33.3845 44.5812 33.0253 C 43.5221 32.661500000000004 42.4649 32.661500000000004 41.305800000000005 32.7765;M 40.9874 52.864 C 43.028800000000004 45.697199999999995 44.2314 35.2482 37.25 28.249999999999996 C 37.25 28.249999999999996 37.25 28.249999999999996 37.25 28.249999999999996"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M 56.3837 18.2694 C 55.9392 17.4906 49.5579 15.6404 44.6353 17.6306 C 43.7704 18.0113 42.9706 18.5396 42.2474 19.1353"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "M 58.529900000000005 14.7806 C 58.529900000000005 14.7806 50.914300000000004 12.7536 45.281800000000004 15.2325 C 44.079 15.7618 42.9667 16.4966 41.9611 17.325;M 50.8896 27.2001 C 49.3076 24.427699999999998 46.0859 23.0302 42.9804 23.7695 C 42.9804 23.7695 42.9804 23.7695 42.9804 23.7695;M 58.529900000000005 14.7806 C 58.529900000000005 14.7806 50.914300000000004 12.7536 45.281800000000004 15.2325 C 44.079 15.7618 42.9667 16.4966 41.9611 17.325"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M 17.9033 20.0482 C 18.0778 19.8522 23.7746 18.1934 28.1186 19.875 C 29.281 20.1535 30.3778 20.6818 31.4265 21.3098"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "M 15.0716 14.286000000000001 C 15.0716 14.286000000000001 22.6872 12.259000000000002 28.3197 14.737900000000002 C 29.5225 15.2672 30.6348 16.002000000000002 31.6404 16.8304;M 25.1521 34.7984 C 25.7731 34.1008 26.5581 33.3845 27.6037 33.0253 C 28.6628 32.661500000000004 29.72 32.661500000000004 30.8791 32.7765;M 15.0716 14.286000000000001 C 15.0716 14.286000000000001 22.6872 12.259000000000002 28.3197 14.737900000000002 C 29.5225 15.2672 30.6348 16.002000000000002 31.6404 16.8304"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M 32.1848 18.6905 C 32.157 16.6256 31.8975 13.9449 30.7586 12.1643 C 31.1534 11.9676 31.6071 11.9259 32.0312 12.0461"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "5000ms",
    repeatCount: "indefinite",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1",
    values: "M 36.4451 15.3662 C 36.12479999999999 13.036 35.2925 9.7255 33.13719999999999 7.4624999999999995 C 33.13719999999999 7.4624999999999995 33.13719999999999 7.4624999999999995 33.13719999999999 7.4624999999999995;M 21.2792 27.2001 C 21.9999 25.8144 23.207 24.746 24.6699 24.2001 C 26.0751 23.4999 27.690399999999997 23.351499999999998 29.2001 23.7792;M 36.4451 15.3662 C 36.12479999999999 13.036 35.2925 9.7255 33.13719999999999 7.4624999999999995 C 33.13719999999999 7.4624999999999995 33.13719999999999 7.4624999999999995 33.13719999999999 7.4624999999999995"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeach);
export default __webpack_public_path__ + "static/media/peach.8141a1db922ebce44a8338e0561755c2.svg";
export { ForwardRef as ReactComponent };